import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

/* Services */
import { HomeService } from './home.service';

/* Routes */
import { HomeRoutingModule } from './home-routing.module';

/* Local components */
import { HeroComponent } from './components/hero/hero.component';
import { RecentVideosComponent } from './components/recent-videos/recent-videos.component';
import { RecentNewsComponent } from './components/recent-news/recent-news.component';
import { HomeComponent } from './home.component';

// import { PartnersComponent } from '../../shared/components/partners/partners.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FeaturedTournamentsComponent } from './components/featured-tournaments/featured-tournaments.component';
import { NgxSkeletonModule } from 'ngx-skeleton';
import { ThemeModule } from 'src/app/@theme/theme.module';
import { FeaturedEventsComponent } from './components/featured-events/featured-events.component';
import { FeaturedRankingsComponent } from './components/featured-rankings/featured-rankings.component';
import { FeaturedChampionsComponent } from './components/featured-champions/featured-champions.component';

@NgModule({
    declarations: [
        HomeComponent,
        HeroComponent,
        RecentNewsComponent,
        RecentVideosComponent,
        FeaturedTournamentsComponent,
        FeaturedEventsComponent,
        FeaturedRankingsComponent,
        FeaturedChampionsComponent
        
    ],
    imports: [CommonModule, RouterModule, HomeRoutingModule, ThemeModule, NgxSkeletonModule],
    exports: [HeroComponent],
    bootstrap: [HomeComponent],
    providers: [HomeService],
})
export class HomeModule {}
